import { createPortal } from 'react-dom'
import { X } from 'lucide-react'
import { useBodyScrollLock } from '@/hooks/useBodyScrollLock'
import modalStyles from '../styles/modals.module.css'
import chromeStyles from '@/components/ui/confirmDialogChrome.module.css'

interface InviteActionsDialogProps {
  isOpen: boolean
  onClose: () => void
  onResend: () => void
  onApply?: () => void
  showApplyNow?: boolean
}

export function InviteActionsDialog({
  isOpen,
  onClose,
  onResend,
  onApply,
  showApplyNow = false,
}: InviteActionsDialogProps) {
  useBodyScrollLock(isOpen)

  if (!isOpen) return null

  const panel = (
    <div
      data-testid="invitee-actions-dialog"
      className={`${modalStyles.modalOverlay} !z-[10001]`}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        data-testid="invitee-actions-dialog-panel"
        className={`${modalStyles.modalContent} ${chromeStyles.modalContentSaveChanges} ${chromeStyles.modalContentInviteActions}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`${chromeStyles.modalSaveChangesHeader} ${chromeStyles.modalInviteActionsHeader}`}>
          <h3 data-testid="invitee-actions-dialog-title">Invite Actions</h3>
          <button
            type="button"
            data-testid="invitee-actions-dialog-close-button"
            className={modalStyles.closeButton}
            onClick={onClose}
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div
          data-testid="invitee-actions-dialog-content"
          className={`${chromeStyles.modalSaveChangesFooter} ${chromeStyles.modalInviteActionsFooter}`}
        >
          <button
            type="button"
            data-testid="invitee-actions-dialog-resend-button"
            className={chromeStyles.btnSaveChangesPrimary}
            onClick={onResend}
          >
            Re-Send Invite
          </button>

          {showApplyNow && onApply ? (
            <button
              type="button"
              data-testid="invitee-actions-dialog-apply-now-button"
              className={chromeStyles.btnSaveChangesSecondary}
              onClick={onApply}
            >
              Apply Now
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )

  return createPortal(panel, document.body)
}
